import { 
  LayoutDashboard, 
  Building2, 
  Users, 
  Layers, 
  Network, 
  Settings, 
  Folder, 
  UserCheck, 
  Shield, 
  GitBranch, 
  SquarePen 
} from 'lucide-react';

const iconMap = {
  'fa-user-tie': Users,
  'fa-folder': Folder,
  'fa-user': Users,
  'fa-address-card': Building2,
  'fa-user-shield': Shield,
  'fa-landmark': Building2,
  'fa-users-gear': UserCheck,
};

const nameIconMap = {
  'Overview': LayoutDashboard,
  'Dashboard': LayoutDashboard,
  'Workspace': Layers,
  'Workspaces': Layers,
  'Workspace Mapping': GitBranch,
  'Company Master': Building2,
  'Company Onboarding': Building2,
  'Companies': Building2,
  'User Master': Users,
  'User Management': Users,
  'Role Master': UserCheck,
  'Usecase User Mapping': GitBranch,
  'Data Sources & Integrations': Network,
  'System Settings': Settings,
  'Authorization': Shield,
  'UseCase Master': Settings,
  'Screen Master': Settings,
  'Use Cases': SquarePen,
  'Usecases': SquarePen,
  'User Model Mapping': UserCheck,  // ← ADD THIS
  'User Model Group Mapping': UserCheck,  // ← ADD THIS (alternative name)
};

const getIconComponent = (iconString, screenName) => {
  if (screenName) {
    // Exact match
    if (nameIconMap[screenName]) return nameIconMap[screenName];
    // Trim whitespace match
    if (nameIconMap[screenName.trim()]) return nameIconMap[screenName.trim()];
  }
  
  if (!iconString) return Folder;
  const match = iconString.match(/fa-(?!solid\b)[\w-]+/);
  if (match) {
    return iconMap[match[0]] || Folder;
  }
  return Folder;
};

const MENU_ORDER = [
  "Overview",
  "Dashboard",
  "Workspace",
  "Workspaces",
  "Workspace Mapping",
  "Company Master",
  "Company Onboarding",
  "User Management",
  "Role Master",
  "User Model Mapping",  // ← ADD THIS - position after Role Master
  "Authorization",
  "UseCase Master",
  "Usecase User Mapping",
  "Screen Master"
];

const sortMenus = (menus) => {
  return [...menus].sort((a, b) => {
    const cleanScreenName = a.screenname?.trim() || a.label?.trim();
    const indexA = MENU_ORDER.indexOf(cleanScreenName);
    const cleanScreenNameB = b.screenname?.trim() || b.label?.trim();
    const indexB = MENU_ORDER.indexOf(cleanScreenNameB);
    
    // If both exist in our order list, compare them
    if (indexA !== -1 && indexB !== -1) return indexA - indexB;
    // If a exists but b doesn't, a comes first
    if (indexA !== -1) return -1;
    // If b exists but a doesn't, b comes first
    if (indexB !== -1) return 1;
    
    // Fallback: alphabetical sort
    return (a.screenname || a.label || "").localeCompare(b.screenname || b.label || "");
  });
};

export const transformMenuData = (menuData) => {
  const menuList = menuData?.menuList || [];
  if (!Array.isArray(menuList)) return [];

  const transformedMenus = menuList.map((item) => {
    const parent = item.parentMenu;
    const children = item.childMenus || [];

    return {
      id: parent.screenId.toString(),
      label: parent.screenname.trim(),
      icon: getIconComponent(parent.menuIcon, parent.screenname),
      path: parent.screenURL === '#' ? `/admin/${parent.screenname.toLowerCase().replace(/\s+/g, '-')}` : parent.screenURL,
      hasChildren: children.length > 0,
      children: sortMenus(children).map((child) => ({
        id: child.screenId.toString(),
        label: child.screenname.trim(),
        icon: getIconComponent(child.menuIcon, child.screenname),
        path: child.screenURL,
      })),
    };
  });
  return transformedMenus;
};